
import React, { useContext, useState, useRef, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import axios from 'axios';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Notifications, Help, ArrowDropDown, Upload, UploadFileOutlined, CloseIcon, CloseRounded, } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Badge,
  Box,
  Select,
  Divider,
  Drawer,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper, Tabs,
} from '@mui/material';
import TextField from '@mui/material/TextField';

import ClearIcon from '@mui/icons-material/Clear';
import Search from '@mui/icons-material/Search';
import Tab from '@mui/material/Tab';
import { formatDistanceToNow, parseISO } from "date-fns";
import {
    CaseDocumentsModel, caseDocumentsModel,
    TextFieldWithIconButton,
    CustomAutoComplete,
    TextFieldDefault,
    DocumentUtility,
    UtilityLibrary,
    caseDataService,
    batchDataService,
    BusinessUtility,
    ApiManager,
    sessionService,
    SessionManager,
    EnumUtility,
    LoggerUtility,
    ConfirmationDialog,
    NotificationDialog,
    FetchControls,
    DeterminePermissions,
    workflowDataService,
} from '../../../components/ComponentsLibrary';
import { ClientType } from '../../../enums/ClientType';


const WorkflowsCaseDetail = forwardRef((props, ref) => {

    const {
        onComponentMount = () => { },
        PrimaryID,
        noCase,
    } = props;

    // Expose the method to the parent via ref
    useImperativeHandle(ref, () => ({
        onLoadWorkflowsByCaseID,
    }));

    useEffect(() => {
        if (onComponentMount) {
            onComponentMount();
        }
    }, []);

    const errorFormName = "Case Detail - Workflow Activities";

    const masterServerDBSchema = SessionManager.GetDataFromSession("SiteSettingsDetailsKey")?.masterDBSchema;

    const { siteID, stateID, legacyUserID: userID, timeZone } = SessionManager.GetDataFromSession("LoginUserInfoKey") || {};
    const currentActivePage = Number(SessionManager.GetValueFromSession("CurrentActivePageKey"));

    const caseDocsDataRefs = useRef([]); // Store DataGrid data persistently
    const pdfViewerRef = useRef(null);

    const [isPageLoading, setIsPageLoading] = useState(false);

    const [resultsWorkflow, setResultsWorkflow] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [gridActivityData, setGridActivityData] = useState([]);
    const [resultsWorkflowActivity, setResultsWorkflowActivity] = useState([]);
    const [selectedWorkflowRow, setSelectedWorkflowRow] = useState(null);
    const [selectedActivityRow, setSelectedActivityRow] = useState([]);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);

    const [paginationModel, setPaginationModel] = useState({ pageSize: 5, page: 0 });
    const [activityPaginationModel, setActivityPaginationModel] = useState({ pageSize: 5, page: 0 });
    const [gridFilterModel, setGridFilterModel] = useState({ items: [] });
    const [activityGridFilterModel, setActivityGridFilterModel] = useState({ items: [] });
    const [sortWorkflowModel, setSortWorkflowModel] = useState([]);

    const [enableShowExternalDocument, setEnableShowExternalDocument] = useState(false);
    const [uncExternalDocumentUrl, setUncExternalDocumentUrl] = useState('');

    const workflowOptions = {
        AllWorkflows: { id: 1, label: "All Workflows", value: "AllWorkflows", workflowID: null },
        Complaints: { id: 2, label: "Complaints", value: "Complaints", workflowID: 141 },
    };

    const [workflowSelected, setWorkflowSelected] = useState('AllWorkflows');
    const [workflowTypeSelected, setWorkflowTypeSelected] = useState(ClientType.DropDownType.Work_Workflows__Open_Workflows);

    const defaultPermissionsForFields = {
        clearFiltersBtn: { read: false, write: true, hide: false },
        exportDocumentsBtn: { read: false, write: true, hide: false },
        workflowActivityDgrd: { read: false, write: true, hide: false },
        documentViewerVwr: { read: false, write: true, hide: false },
        docVwr1Editor: { read: false, write: true, hide: false },
        docVwr1ToolbarItems: { read: false, write: true, hide: false },
        docVwr2Editor: { read: false, write: true, hide: false },
        docVwr2ToolbarItems: { read: false, write: true, hide: false },
        docVwrSplitBtn: { read: false, write: true, hide: false },
    }
    const [formFieldAccess, setFormFieldAccess] = useState(defaultPermissionsForFields);

    const customDateFormat = "MM/DD/YYYY hh:mm A";
    const customTimeFormat = "HH:mm:ss";

    const [complaintSourceOptions, setComplaintSourceOptions] = useState([{ complaintSource: 'CP' }]);
    const [complaintTypeOptions, setComplaintTypeOptions] = useState([{ complaintType: 'Failure to return call' }]);

    const initialFormValues = {
        complaintSource: 'CP',
        complaintType: 'Failure to return call',
    };

    const [formValues, setFormValues] = useState(initialFormValues);
    const [isComplaintEnabled, setIsComplaintEnabled] = useState(false);
    const [workflowTypeOptions, setWorkflowTypeOptions] = useState([]);

    const workflowGridColumns = [
        { 
        field: 'related', 
        headerName: 'Related', 
        minWidth: 100,
        type: 'boolean',
        editable: true,
        renderCell: (params) => (
            <Checkbox
                checked={params.value || false}
                disabled={true}
            />
        )},
        { field: 'caseWorkflowID', headerName: 'Workflow No.', minWidth: 130 },
        { field: 'workflowName', headerName: 'Workflow', minWidth: 150 },
        { field: 'caseWorkflowCreatedTS', headerName: 'Workflow Started', type: 'dateTime', valueFormatter: (value) => value && UtilityLibrary.formatDate(value, customDateFormat), minWidth: 200},
        { field: 'startingEvent', headerName: 'Starting Event (Choice)', minWidth: 300 },
        { field: 'completedTS', headerName: 'Workflow Completed', type: 'dateTime', valueFormatter: (value) => value && UtilityLibrary.formatDate(value, customDateFormat), minWidth: 200 },
        { field: 'completedLastAction', headerName: 'Completing Event (Last Action Taken)', minWidth: 350 },
        { field: 'workflowDuration', headerName: 'Business Day From Start to Complete', minWidth: 120},
        { field: 'completedLastActionUser', headerName: 'Completed By', minWidth: 150 },
        { field: 'tracNote', headerName: 'Notes', minWidth: 300},
    ];

    const complaintsGridRows = [
        { id: 1, related: '', workflowNo: 265, workflow: 'Complaints', workflowStarted: '8/16/2024 12:03:34 PM', startingEvent: 'Added WF (Work)-Complaint-CP', workflowCompleted: '8/16/2024 02:06:14  pm', },
        { id: 2, related: '', workflowNo: 355, workflow: 'Complaints', workflowStarted: '7/28/2024 11:03:16 AM', startingEvent: 'System-Referred WF-Complaints', workflowCompleted: '7/28/2024 3:14:26 PM', },
    ];

    // Grid Columns: Test Data Documents for a Case Number
    const workflowActivityGridColumns = [
        { field: 'caseWorkflowID', headerName: 'Workflow No.', minWidth: 130 },
        { field: 'workflowName', headerName: 'Workflow', minWidth: 150 },
        { field: 'departmentName', headerName: 'Queue', minWidth: 150 },
        { field: 'createdTS', headerName: 'Date', type: 'dateTime', valueFormatter: (value) => value && UtilityLibrary.formatDate(value, customDateFormat), minWidth: 200 },
        { field: 'contactID', headerName: 'Y-Trac Contact ID', valueFormatter: (value) => value === 0 ? '' : value, minWidth: 150 },
        { field: 'workflowActionTypeReportName', headerName: 'Action Taken', minWidth: 300 },
        { field: 'userName', headerName: 'Action By', minWidth: 150 },
        { field: 'workTime', headerName: 'Task Work Time', minWidth: 140 },
        { field: 'nextWorkflowName', headerName: 'Next Action Workflow', minWidth: 180 },
        { field: 'nextDepartmentName', headerName: 'Next Action Queue', minWidth: 160 },
        { field: 'nextWorkflowStepName', headerName: 'Next Action Type', minWidth: 300 },
        { field: 'nextStepDueTS', headerName: 'Next Action Due', type: 'dateTime', valueFormatter: (value) => value && UtilityLibrary.formatDate(value, customDateFormat), minWidth: 200 },
        { field: 'activityNoteContent', headerName: 'Trac Note',minWidth: 300},
        { field: 'narrativeContent', headerName: 'Narrative', minWidth: 500 },
    ];


    const complaintActivityGridRows = [
        { id: 1, workflowNo: 265, workflow: 'Complaints', queue: 'Complaints-Add', date: '8/16/2024 12:03:34 PM', yTracContactID: '', actionTaken: 'Added WF (Work)-Complaint-CP', },
    ];

    const [workflowsStarted, setWorkflowsStarted] = useState(0);
    const [workflowsCompleted, setWorkflowsCompleted] = useState(0);
    const [averageBusinessDays, setAverageBusinessDays] = useState(0);
    const [workflowActivityCount, setWorkflowActivityCount] = useState(0);
    const [dynamicWorkflowOptions, setDynamicWorkflowOptions] = useState({AllWorkflows: { id: 1, label: "All Workflows", value: "AllWorkflows", workflowID: null },});

    //=======================================================================
    //  - Begin
    //=======================================================================

    const simulateAsyncDelay = async () => {
        await new Promise((resolve) => setTimeout(resolve, 0));
    }

    const onLoadWorkflowsByCaseID = async (workflowID = null) => {
        // const isComplaint = workflowValue === 'Complaints';
        const caseID = PrimaryID;

        let paramObj = {};
        let addtnParamsGrid1 = {};
        let paramObjGrid1 = {};
        let paramObjGrid2 = {};

        if(!noCase) {
            paramObj = {
                caseNumber: caseID,
                YTracSiteID: siteID,
                masterServerDBSchema,
                workflowID,
                systemTimeZoneName: timeZone
            };
            
            addtnParamsGrid1 = {
                DepartmentID: null,
                UserLoginID: userID,
                BoardedSiteID: stateID,
                moduleID: 1,
                WorkflowStateLockoutTimer: 60,
                ExportMode: null
            };
            paramObjGrid1 = {...paramObj, ...addtnParamsGrid1};

            paramObjGrid2 = {...paramObj, reCount: 0, caseWorkflowID: 0,};
        } else {
            paramObj = {
                caseWorkflowID: caseID,
                YTracSiteID: siteID,
                masterServerDBSchema,
                workflowID,
                systemTimeZoneName: timeZone
            };
            
            addtnParamsGrid1 = {
                DepartmentID: null,
                UserLoginID: userID,
                BoardedSiteID: stateID,
                moduleID: 1,
                WorkflowStateLockoutTimer: 60
            };
            paramObjGrid1 = {...paramObj, ...addtnParamsGrid1};
        }

        try {

            let apiDataGrid1 = [];

            if(!noCase) {
                apiDataGrid1 = await workflowDataService.getWorkflowActivityFromApiByCaseID(paramObjGrid1, 'workflows');
            } else {
                apiDataGrid1 = await workflowDataService.getNoCaseWorkflowActivityFromApi(paramObjGrid1, 'noCaseWorkflows');
            }

            const apiDataGrid1WithIds = apiDataGrid1.map((item, index) => (
                { ...item, id: index }));
            setResultsWorkflow(apiDataGrid1WithIds);

            // Open-Completed Workflows Dropdown
            const params = {
                DropdownCategoryTypeID: Number(ClientType.DropdownCategoryType.Work_Workflows),
            };
            const apiWfStatusOptions = await workflowDataService.getWorkflowStatusOptions(params);

            const dropdownOptions = apiWfStatusOptions.map((option, idx) => ({
                "id": idx,
                "label": option.dropdownTypeName,
                "value": option.dropdownTypeID
            }));
            setWorkflowTypeOptions(dropdownOptions);
            // set open by default
            setWorkflowTypeSelected(dropdownOptions.find(option => option.value === ClientType.DropDownType.Work_Workflows__Open_Workflows)?.value);
            
            //Grid 2
            let apiDataGrid2 = [];

            if(!noCase) {
                apiDataGrid2 = await workflowDataService.getWorkflowActivityFromApiByCaseID(paramObjGrid2, 'workflowActivities');
            } else {
                apiDataGrid2 = await workflowDataService.getNoCaseWorkflowActivityFromApi(paramObj, 'workflowActivities');
            }

            const apiDataGrid2WithIds = apiDataGrid2.map((item, index) => (
                { ...item, id: index }));
            setResultsWorkflowActivity(apiDataGrid2WithIds);
            // complaint
            // isComplaint ? setIsComplaintEnabled(true): setIsComplaintEnabled(false);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "onLoadWorkflowsByCaseID");
        }
    };

    const numberOfOpenAndCompletedWorkflows = (data) => {

        let openWorkflows = [];
        let completedWorkflows = [];

        if (!data || data.length === 0) return { open: 0, completed: 0 };

        switch (workflowTypeSelected) {
            case ClientType.DropDownType.Work_Workflows__Open_Workflows:
                    openWorkflows = data.filter(row => row.statusTypeID === 6);
                    completedWorkflows = [];
                break;

                case ClientType.DropDownType.Work_Workflows__Completed_Workflows:
                    openWorkflows = data.filter(row => row.statusTypeID === 8);
                    completedWorkflows = data.filter(row => row.statusTypeID === 8);
                break;

                case ClientType.DropDownType.Work_Workflows__Open_And_Completed_Workflows:
                    openWorkflows = data;
                    completedWorkflows = data.filter(row => row.statusTypeID === 8);
                break;

            default:
                break;
        }

        let avgBusDays = 0;
        if (completedWorkflows.length > 0) {
            const totalDuration = completedWorkflows.reduce((sum, row) => {
                const dur = parseFloat(row.workflowDuration) || 0;
                return sum + dur;
            }, 0);
            avgBusDays = totalDuration / completedWorkflows.length;
        }
    
        return {
            open: openWorkflows.length,
            completed: completedWorkflows.length,
            avgBusDays: parseFloat(avgBusDays.toFixed(2)) 
        };
    }

    useEffect(() => {
        if (resultsWorkflow && resultsWorkflow.length > 0) {
            let filtered = [...resultsWorkflow];
            let filteredActivity = [...resultsWorkflowActivity];

            const { open: openWorkflowsCount, completed: completedWorkflowsCount, avgBusDays: averageBusDays } = numberOfOpenAndCompletedWorkflows(filtered);
            const openWorkflows = filtered.filter(w => w.statusTypeID === 6);   
            setGridData(openWorkflows); // default: Open Workflows

            let firstActivityWorkflow = [];
            if(filteredActivity.length > 0 && openWorkflows.length > 0) {
                const firstCaseWorkflowID = openWorkflows[0]?.caseWorkflowID;
                firstActivityWorkflow = filteredActivity.filter(a => a.caseWorkflowID === firstCaseWorkflowID && a.statusTypeID === 6);
                
                // Set the first workflow as selected when activities are displayed
                if (firstActivityWorkflow.length > 0) {
                    setSelectedWorkflowRow(openWorkflows[0]);
                    setRowSelectionModel([openWorkflows[0].id]);
                }
            }

            setGridActivityData(firstActivityWorkflow);
            setWorkflowsStarted(openWorkflowsCount);
            setWorkflowsCompleted(completedWorkflowsCount);
            setAverageBusinessDays(averageBusDays);
            setWorkflowActivityCount(firstActivityWorkflow.length);
        }
    }, [resultsWorkflow, resultsWorkflowActivity]);


    const handleWorkflowChange = (e) => {
        let value = e.target.value;

        setWorkflowSelected(value);
        let filtered = [...resultsWorkflow];

        if (value !== "AllWorkflows") {
            const workflowID = Number(value); 
            filtered = filtered.filter(row => row.workflowID === workflowID);
        }

        let filteredActivity = [];
        if(filtered.length > 0) {
            const firstCaseWorkflowID = filtered[0]?.caseWorkflowID;
            filteredActivity = [...resultsWorkflowActivity].filter(a => a.caseWorkflowID === firstCaseWorkflowID);
            
            // Set the first workflow as selected when activities are displayed
            if (filteredActivity.length > 0) {
                setSelectedWorkflowRow(filtered[0]);
                setRowSelectionModel([filtered[0].id]);
            } else {
                setSelectedWorkflowRow(null);
                setRowSelectionModel([]);
            }
        } else {
            setSelectedWorkflowRow(null);
            setRowSelectionModel([]);
        }

        setGridData(filtered);
        setGridActivityData(filteredActivity);

        const { open: openWorkflowsCount, completed: completedWorkflowsCount , avgBusDays: avgBusinessDays} = numberOfOpenAndCompletedWorkflows(filtered);
        setWorkflowsStarted(openWorkflowsCount);
        setWorkflowsCompleted(completedWorkflowsCount);
        setAverageBusinessDays(avgBusinessDays);
        setWorkflowActivityCount(filteredActivity.length);
    };

    const handleWorkflowTypeChange = (e) => {
        const { value } = e.target;
        setWorkflowTypeSelected(value);
    };

    useEffect(() => {
        if (!resultsWorkflow) return;

        let filtered = [...resultsWorkflow];
        let isOpenOrCompleted = false;

        if (workflowTypeSelected === ClientType.DropDownType.Work_Workflows__Open_Workflows) {
            filtered = filtered.filter(row => row.statusTypeID === 6);
            isOpenOrCompleted = true;
        } else if (workflowTypeSelected === ClientType.DropDownType.Work_Workflows__Completed_Workflows) {
            filtered = filtered.filter(row => row.statusTypeID === 8);
            isOpenOrCompleted = true;
        } else { 
            filtered = [...resultsWorkflow];
            isOpenOrCompleted = false;
        }

        if (workflowSelected && workflowSelected !== "AllWorkflows") {
            const workflowID = Number(workflowSelected);
            filtered = filtered.filter(row => row.workflowID === workflowID);
        }

        const { open: openWorkflowsCount, completed: completedWorkflowsCount, avgBusDays: avgBusinessDays } = numberOfOpenAndCompletedWorkflows(filtered);
        setWorkflowsStarted(openWorkflowsCount);
        setWorkflowsCompleted(completedWorkflowsCount);
        setAverageBusinessDays(avgBusinessDays);

        let filteredActivity = [];
        if(filtered.length > 0) {
            const firstCaseWorkflowID = filtered[0]?.caseWorkflowID;
            filteredActivity = [...resultsWorkflowActivity].filter(a => a.caseWorkflowID === firstCaseWorkflowID);
            
            // Set the first workflow as selected when activities are displayed
            if (filteredActivity.length > 0) {
                setSelectedWorkflowRow(filtered[0]);
                setRowSelectionModel([filtered[0].id]);
            } else {
                setSelectedWorkflowRow(null);
                setRowSelectionModel([]);
            }
        } else {
            setSelectedWorkflowRow(null);
            setRowSelectionModel([]);
        }

        setGridActivityData(filteredActivity);
        setWorkflowActivityCount(filteredActivity.length);
        setGridData(filtered);      
    }, [workflowSelected, workflowTypeSelected]);
    
    const handleWorkflowRowClick = (params) => {
        const caseWorkflowID = params.row.caseWorkflowID;
        setSelectedWorkflowRow(params.row);
        setRowSelectionModel([params.row.id]);
        if (!caseWorkflowID) return;

        const selectedActivityRow = resultsWorkflowActivity.filter(a => a.caseWorkflowID === caseWorkflowID);
        setWorkflowActivityCount(selectedActivityRow.length);
        setGridActivityData(selectedActivityRow);
    };

    const handleGridFilterChange = async (newFilterModel) => {
        try {
            setGridFilterModel(newFilterModel);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridFilterChange");
        }
    };

    const handleGridClearFilters = async () => {
        try {
            setGridFilterModel({ items: [] });
            setActivityGridFilterModel({ items: [] });
            setSortWorkflowModel([]);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridClearFilters");
        }
    };

    const getUniqueWorkflowNames = (resultsWorkflow) => {
        const map = new Map();

        resultsWorkflow.forEach(row => {
            const workflowName = row.workflowName;
            const workflowID = row.workflowID;

            if (workflowName && workflowID) {
                const key = `${workflowName}_${workflowID}`;
                if (!map.has(key)) {
                    map.set(key, {
                    key,
                    name: workflowName,
                    id: workflowID,
                    value: workflowID
                    });
                }
            }
        });

        return Array.from(map.values());
    };
    
    useEffect(() => {
        if (!resultsWorkflow || resultsWorkflow.length === 0) return;

        const uniqueWorkflows = getUniqueWorkflowNames(resultsWorkflow);

        setDynamicWorkflowOptions(prev => {
            const newOptions = {
            ...prev, // keep old ones
            AllWorkflows: { id: "all", label: "All Workflows", value: "AllWorkflows", workflowID: null }
            };

            uniqueWorkflows.forEach(wf => {
                newOptions[wf.key] = {
                    id: wf.id,
                    label: wf.name,
                    value: wf.id,
                    workflowID: wf.id,
                    workflowName: wf.name
                };
            });

            return newOptions;
        });
    }, [resultsWorkflow]);

    //=======================================================================
    //  - End
    //=======================================================================


    //=======================================================================
    // Tabs Feature - Begin
    //=======================================================================


    //=======================================================================
    // Tabs Feature - End
    //=======================================================================



    const mainWorkflowsContent = (
        <div style={{ padding: '10px 5px 5px', width: '100%' }}>
            <div>{/* Middle Section - Document Grid and Buttons  */}
                <Paper elevation={2} className="document-grid" sx={{ boxShadow: "none" }}>
                    <div className="two-column-layout-container">
                        <div className="left-column-custom-1">
                            <div className="text-wrapper-subtitle" style={{ paddingLeft: '10px' }}>
                                Workflow:
                            </div>
                            <div>
                                {!(formFieldAccess.workflowTypeSelect?.hide ?? false) && (
                                    <div>
                                        <FormControl fullWidth>
                                            <InputLabel id="workflow-select-label" shrink={true}></InputLabel>
                                            <Select
                                                size="small"
                                                labelId="workflow-select-label"
                                                id="workflowSelect"
                                                name="workflowSelect"
                                                value={workflowSelected || "AllWorkflows"}
                                                IconComponent={ArrowDropDown}
                                                displayEmpty
                                                onChange={handleWorkflowChange}
                                            >
                                                {Object.entries(dynamicWorkflowOptions).map(([key, option]) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="right-column-custom-1">
                            {!(formFieldAccess.clearFiltersBtn?.hide ?? false) && (
                                <Button id="clearFiltersBtn" name="clearFiltersBtn" variant="text" color="ywTextBlue" className="clear-filters-btn" onClick={handleGridClearFilters} disabled={!(formFieldAccess.clearFiltersBtn?.write ?? true)}>CLEAR FILTERS</Button>
                            )}
                            {!(formFieldAccess.workflowTypeSelect?.hide ?? false) && (
                                <div>
                                    <FormControl fullWidth>
                                        <InputLabel id="workflow-type-select-label" shrink={true}></InputLabel>
                                        <Select
                                            size="small"
                                            labelId="workflow-type-select-label"
                                            id="workflowTypeSelect"
                                            name="workflowTypeSelect"
                                            value={workflowTypeSelected}
                                            IconComponent={ArrowDropDown}
                                            displayEmpty
                                            onChange={handleWorkflowTypeChange}
                                        >
                                            {Object.entries(workflowTypeOptions).map(([key, option]) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            )}
                        </div>
                    </div>
                    {!(formFieldAccess.workflowActivityDgrd?.hide ?? false) && (
                        <div style={{ display: "flex", flexDirection: "column", marginTop: '4px', height: "100%", width: "100%", overflowX: "auto" }}>
                            <DataGridPremium
                                id="workflowsDgrd"
                                name="workflowsDgrd"
                                rows={gridData}
                                columns={workflowGridColumns}
                                pagination
                                pageSizeOptions={[5, 10, 15, 20, 25]}
                                paginationModel={paginationModel} // Controlled pagination
                                onPaginationModelChange={setPaginationModel} // Handle page changes 
                                filterModel={gridFilterModel}
                                onFilterModelChange={handleGridFilterChange}
                                sortModel={sortWorkflowModel}
                                onSortModelChange={setSortWorkflowModel}
                                onRowClick={handleWorkflowRowClick}
                                rowSelectionModel={rowSelectionModel}
                                onRowSelectionModelChange={setRowSelectionModel}
                                checkboxSelection={false}
                                hideFooterSelectedRowCount={true}
                                autosizeOnMount
                                autosizeOptions={{
                                    includeHeaders: true,
                                    includeOutliers: true,
                                    expand: true
                                }}
                                sx={{
                                    "& .MuiDataGrid-row:hover": {
                                      cursor: "pointer"
                                    },
                                    ".MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": {
                                      "margin-top": "1em",
                                      "margin-bottom": "1em"
                                    },
                                    "& .MuiDataGrid-virtualScroller": { overflowX: "auto", overflowY: "auto" }
                                  }}
                            />
                        </div>
                    )}
                    <div className="two-column-layout-container" style={{ marginTop: '14px' }}>
                        <div className="left-column-custom-1">
                            <div className="text-wrapper-subtitle" style={{ paddingLeft: '12px' }}>
                                Totals:
                            </div>
                            <div className="text-wrapper-subtitle" style={{ paddingLeft: '12px' }}>
                                Workflows Started: {workflowsStarted}
                            </div>
                            <div className="text-wrapper-subtitle" style={{ paddingLeft: '12px' }}>
                                Workflows Completed: {workflowsCompleted}
                            </div>
                            <div className="text-wrapper-subtitle" style={{ paddingLeft: '12px' }}>
                                Average Business Days: {averageBusinessDays}
                            </div>
                        </div>
                    </div>
                </Paper>
            </div>
            <div style={{ padding: '10px 5px 5px', width: '100%' }}>
                <Paper elevation={2} className="document-grid" sx={{ boxShadow: "none" }}>
                    <div className="two-column-layout-container">
                        <div className="left-column-custom-1">
                            <div className="text-wrapper-subtitle" style={{ paddingLeft: '10px' }}>
                                Workflow Activities:
                            </div>
                        </div>
                        <div className="right-column-custom-1">
                            {!(formFieldAccess.clearFiltersBtn?.hide ?? false) && (
                                <Button id="clearFiltersBtn" name="clearFiltersBtn" variant="text" color="ywTextBlue" className="clear-filters-btn" onClick={handleGridClearFilters} disabled={!(formFieldAccess.clearFiltersBtn?.write ?? true)}>CLEAR FILTERS</Button>
                            )}
                        </div>
                    </div>
                    {!(formFieldAccess.workflowActivityDgrd?.hide ?? false) && (
                        <div style={{ display: "flex", flexDirection: "column", marginTop: '4px', height: "100%", width: "100%", overflowX: "auto" }}>
                            <DataGridPremium
                                id="workflowActivityDgrd"
                                name="workflowActivityDgrd"
                                rows={gridActivityData}
                                columns={workflowActivityGridColumns}
                                pagination
                                pageSizeOptions={[5, 10, 15, 20, 25]}
                                paginationModel={activityPaginationModel} // Controlled pagination
                                onPaginationModelChange={setActivityPaginationModel} // Handle page changes
                                filterModel={activityGridFilterModel}
                                onFilterModelChange={(newFilterModel) => setActivityGridFilterModel(newFilterModel)}
                                autosizeOnMount
                                autosizeOptions={{
                                    includeHeaders: true,
                                    includeOutliers: true,
                                    expand: true
                                }}
                                sx={{
                                    "& .MuiDataGrid-row:hover": {
                                      cursor: "pointer"
                                    },
                                    ".MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": {
                                      "margin-top": "1em",
                                      "margin-bottom": "1em"
                                    },
                                    "& .MuiDataGrid-virtualScroller": { overflowX: "auto", overflowY: "auto" }
                                  }}
                            />
                        </div>
                    )}
                    <div className="two-column-layout-container" style={{ marginTop: '14px' }}>
                        <div className="left-column-custom-1">
                            <div className="text-wrapper-subtitle" style={{ paddingLeft: '12px' }}>
                                Totals:
                            </div>
                            <div className="text-wrapper-subtitle" style={{ paddingLeft: '12px' }}>
                                Actions Taken: {workflowActivityCount || 0}
                            </div>
                            <div className="text-wrapper-subtitle" style={{ paddingLeft: '12px' }}>
                                Task Work Time: 00:00:00
                            </div>
                        </div>
                    </div>
                </Paper>
            </div>
            {isComplaintEnabled && (
                <div style={{ padding: '10px 5px 5px', width: '100%' }}>
                    <Paper elevation={2} className="document-grid" sx={{ boxShadow: "none" }}>
                        <div className="two-column-layout-container">
                            <div className="left-column-custom-1">
                                <div className="text-wrapper-subtitle" style={{ paddingLeft: '10px' }}>
                                    Complaint Details:
                                </div>
                            </div>
                            <div className="right-column-custom-1">
                                {!(formFieldAccess.saveBtn?.hide ?? false) && (
                                    <Button id="saveBtn" name="saveBtn" color="ywButtonBlack" variant='contained' className='me-2' >Save</Button>
                                )}
                                {!(formFieldAccess.clearFiltersBtn?.hide ?? false) && (
                                    <Button id="editBtn" name="editBtn" variant="text" color="ywTextBlue" className="clear-filters-btn" onClick={handleGridClearFilters} disabled={!(formFieldAccess.clearFiltersBtn?.write ?? true)}>Edit</Button>
                                )}
                            </div>
                        </div>
                        <div className="form-grid-container-2c" style={{ padding: '10px 5px 5px', width: '100%' }}>
                            <div>
                                <FormControl fullWidth>
                                    <TextFieldDefault label="Complainant First" InputLabelProps={{ shrink: true }}                                        
                                        id="complainantFirstTxt"
                                        name="complainantFirstTxt"
                                        value="Bob"

                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton>
                                                        <ClearIcon color="ywButtonBlue" />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </FormControl>
                            </div>
                            <div>
                                <FormControl fullWidth>
                                    <TextFieldDefault label="Complainant Last" InputLabelProps={{ shrink: true }}
                                        id="complainantLastTxt"
                                        name="complainantLastTxt"
                                        value="Smith"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton>
                                                        <ClearIcon color="ywButtonBlue" />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </FormControl>
                            </div>
                            <div>
                                <CustomAutoComplete
                                    idForControl='complaintSourceSelect'
                                    labelForControl='Complaint Source'
                                    valueForControl={formValues.complaintSource}
                                    optionsSource={complaintSourceOptions}
                                    labelKey='complaintSource'
                                    valueKey='complaintSource'
                                    noOptionsText='Complaint Source Not Found'
                                />
                            </div>
                            <div>
                                <CustomAutoComplete
                                    idForControl='complaintTypeSelect'
                                    labelForControl='Complaint Type'
                                    valueForControl={formValues.complaintType}
                                    optionsSource={complaintTypeOptions}
                                    labelKey='complaintType'
                                    valueKey='complaintType'
                                    noOptionsText='Complaint Type Not Found'
                                />
                            </div>
                        </div>
                    </Paper>
                </div>
            )}
        </div>
    );



    return (
        <div style={{ height: '100%' }}>
            {mainWorkflowsContent}
        </div>
    );
});

export default WorkflowsCaseDetail;


